import { EntityOperation, Message } from '@msdk/definitions'

export function messagesFromEntityOperation(op: EntityOperation): Message[] {
  const messageGroups = op.messages?.entities || []
  let messages: Message[] = []

  messageGroups.forEach((g) => {
    const mItems = g.items?.['']
    if (mItems && mItems.messages) {
      messages = messages.concat(mItems.messages)
    }
  })

  return messages
}
